import { Component, OnInit, ChangeDetectorRef, ViewChild, Output } from "@angular/core";
import { Store } from "@ngrx/store";
import { FileUpload } from "primeng/fileupload";
import { Subject } from "rxjs";
import { switchMap } from "rxjs/operators";
import { ShippingError, ShippingErrorProduct, ShippingProductList} from "src/app/models/dashboard/shipping-error";
import { ProUser } from "src/app/models/pro-user";
import { AuthService } from "src/app/services/auth.service";
import { DataService } from "src/app/services/data.service";
import { ErrorMessageSet, SetDashboardTitle, SuccessMessageSet } from "src/app/store/actions/site.actions";
import { IAppState } from "src/app/store/state/app.state";
import { forEachChild } from "typescript";
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-shipping-errors-form',
  templateUrl: './shipping-errors-form.component.html',
  styleUrls: ['./shipping-errors-form.component.scss']
})


export class ShippingErrorsFormComponent implements OnInit {
  @ViewChild('packingSlipUploads') packingSlipUploads: FileUpload;
  @ViewChild('damagePhotoUploads') damagePhotoUploads: FileUpload;

  @Output() onSubmit: Subject<ShippingError> = new Subject();

  public openTab: "OverageShortage" | "Damaged" | "Wrong" = "OverageShortage";
  private user: ProUser;
  public shippingError: ShippingError = new ShippingError();
  public affectedProducts: Array<ShippingErrorProduct> = [];
  public willForward: boolean;
  public keepDamagedProducts: boolean;
  public upsNotified: boolean;
  public keepOrRma: 'keep' | 'rma' | undefined;
  public files: Set<File> = new Set();
  public packingSlipFiles: Array<string> = [];
  public submitted: boolean = false;
  public storeNameSupplied: boolean = false;
  public approximateCounter: number = 0;
  public ShipNumber: string;
  public notInShipping: boolean;
  public exceedsShortage: boolean;
  public ShippingProducts: Array<ShippingProductList> = [];
  public isShownSerial: boolean = false; // hidden by default
  public validationErrors: string[] = [];
  private _selectedErrorType: 'OverageShortage' | 'Damaged' | 'Wrong' | null = null;
  public showProductList = true;


  public overageShortageOptions = [
    { label: 'Overage', value: 'Overage' },
    { label: 'Shortage', value: 'Shortage' },
    { label: 'Did Not Order', value: 'DidNotOrder' },
  ]
  constructor(private store: Store<IAppState>, private authService: AuthService, private dataService: DataService, private changeDetector: ChangeDetectorRef, private messageService: MessageService) { }

  ngOnInit(): void
  {
    this.user = this.authService.user;
    this.shippingError = this.freshShippingError();



    if (this.selectedErrorType && this.openTab !== this.selectedErrorType) {
      this.openTab = this.selectedErrorType;
    }


  }


  toggleProductList() {
    this.showProductList = !this.showProductList;
  }





  freshShippingError() {
    let shippingError = new ShippingError();
    shippingError.userId = this.user.userId;
    shippingError.accountNumber = this.user.accountNumber;
    let name = this.user.name.split(' ');
    shippingError.lastName = name.pop();
    shippingError.firstName = name.join(' ');
    shippingError.email = this.user.email;
    shippingError.ShipNumber = this.ShipNumber;

    this.dataService.getCompanyData().subscribe(resp => {
    this.shippingError.storeName = resp.company;
    this.storeNameSupplied = true;
    });
    return shippingError;
  }
  setTab(tab) {
    this.openTab = tab;
  }
  onSelect(event, location) {
    switch (location) {
      case 'packingslip': this.packingSlipFiles = event.currentFiles.map(f => f.name); break;
    }
    event.currentFiles.forEach(f => this.files.add(f));
  }
  onRemove(event, location) {
    switch (location) {
      case 'packingslip': this.packingSlipFiles = this.packingSlipFiles.filter(f => f != event.file.name)
    }
  }

  setShipNumber(shipNumber) {
    this.ShipNumber = shipNumber;
  }

  setProduct(product, ap) {
    ap.productCode = product.productCode;
    ap.description = product.modelName;
  }
  addNew(type) {
    switch (type) {
      case 'overage':
        this.affectedProducts.push(new ShippingErrorProduct({ index: this.approximateCounter++ })); break;
      case 'damage':
        this.affectedProducts.push(new ShippingErrorProduct({ errorType: 'Damaged', index: this.approximateCounter++ })); break;
      default:
        this.affectedProducts.push(new ShippingErrorProduct({ index: this.approximateCounter++ })); break;
    }
  }
  deleteProduct(i) {
    const removed = this.affectedProducts.find(p => p.index === i);
    this.affectedProducts = this.affectedProducts.filter(p => p.index != i);

    if (removed) {
      this.messageService.add({
        severity: 'info',
        summary: 'Product Removed',
        detail: `${removed.productCode} was removed from the list.`,
        life: 2000
      });
    }
  }


  get selectedErrorType(): 'OverageShortage' | 'Damaged' | 'Wrong' | null {
    return this._selectedErrorType;
  }

  set selectedErrorType(value: 'OverageShortage' | 'Damaged' | 'Wrong' | null) {
    this._selectedErrorType = value;

    if (value && this.openTab !== value) {
      this.openTab = value;
    }
  }

  AddSerial(event)
  {
    //console.log('event :' + event);
    //console.log(event.value);

    if (event.value == "Overage")
      this.isShownSerial = true;
      //!this.isShownSerial;
  }

  submit() {
    this.submitted = true;
    this.validationErrors = []; // Reset previous errors

    this.affectedProducts = this.affectedProducts.filter(p => !p.isEmpty);
    this.shippingError.products = this.affectedProducts;
    this.shippingError.ShipNumber = this.ShipNumber;

    let valid = this.shippingError.isValid;

    if (!this.shippingError.products.length) {
      valid = false;
      this.validationErrors.push("Add at least one product to submit.");
    }

    if (!this.ShipNumber) {
      valid = false;
      this.validationErrors.push("Select a shipping order number.");
    }

    this.dataService.searchShippingProds(this.ShipNumber).subscribe((resp) => {
      this.ShippingProducts = resp;

      for (let entered of this.shippingError.products) {
        let shipProd = this.ShippingProducts.find(sp => sp.productCode === entered.productCode);

        if (!shipProd && entered.errorType !== 'Overage') {
          valid = false;
          this.validationErrors.push(`${entered.productCode}: not found in shipping log.`);
        }

        if (
          entered.errorType === 'Shortage' &&
          entered.quantity &&
          shipProd &&
          entered.quantity > shipProd.productQuantity
        ) {
          valid = false;
          this.validationErrors.push(`${entered.productCode}: shortage exceeds billed quantity (${shipProd.productQuantity}).`);
        }
      }

      if (valid) {
        const files: File[] = Array.from(this.files);
        this.dataService.saveShippingError(this.shippingError)
          .pipe(
            switchMap((id: number) => this.dataService.saveShippingErrorFiles(id, files))
          )
          .subscribe(() => {
            this.onSubmit.next(this.shippingError);
            this.store.dispatch(new SuccessMessageSet("TShipping error successfully submitted."));
            this.shippingError = this.freshShippingError();
            this.affectedProducts = [new ShippingErrorProduct()];
            this.submitted = false;
            this.packingSlipUploads.clear();
            this.damagePhotoUploads?.clear();
            this.files.clear();
            window.scrollTo(0, 0);
            this.changeDetector.detectChanges();
 
          });
      } else {
        if (this.validationErrors.length === 0) {
          this.validationErrors.push("Fill in all required fields before submitting.");
        }
        this.store.dispatch(new ErrorMessageSet("Please review errords."));
      }
    });
  }






	get affectedProductsOverage() {
		return this.affectedProducts.filter(p => p.errorType == 'Overage' || p.errorType == 'Shortage' || p.errorType == 'DidNotOrder' || p.errorType == '')
	}
	get affectedProductsDamaged() {
		return this.affectedProducts.filter(p => p.errorType == 'Damaged' || p.errorType == '')
	}
	get affectedProductsNotMine() {
		return this.affectedProducts.filter(p => p.errorType == 'NotMine' || p.errorType == '')
	}
	get hasOverages() {
		return this.affectedProducts.some(p => p.errorType == 'Overage' || p.errorType == 'DidNotOrder')
	}
	get hasDamaged() {
		return this.affectedProducts.some(p => p.errorType == 'Damaged')
  }

  addFromPO(p: ShippingProductList) {
    const exists = this.affectedProducts.some(ap => ap.productCode === p.productCode);
    if (exists) return;

    const inferredType =
      this.openTab === 'Damaged' ? 'Damaged' :
        this.openTab === 'Wrong' ? 'NotMine' :
          'Shortage';

    const newProduct = new ShippingErrorProduct({
      index: this.approximateCounter++,
      productCode: p.productCode || '',
      description: p.productDescription,
      quantity: null,
      errorType: inferredType
    });

    this.affectedProducts.push(newProduct);

    this.messageService.add({
      severity: 'success',
      summary: 'Product Added',
      detail: `${p.productCode} added to ${inferredType} list.`,
      life: 2000
    });

    setTimeout(() => {
      const i = this.affectedProducts.findIndex(ap => ap.index === newProduct.index);
      if (i !== -1) {
        this.affectedProducts[i] = new ShippingErrorProduct({
          ...this.affectedProducts[i],
          productCode: p.productCode
        });
      }
    });
  }

}

